import { Tabs, type TabsProps } from "antd";
import type { FC } from "react";
import { useAudienceContext } from "../providers/AudienceContext";

export interface AudienceTabsProps
	extends Omit<TabsProps, "activeKey" | "onChange" | "items"> {
	// No children prop needed - tabs are registered via context
}

const AudienceTabs: FC<AudienceTabsProps> = ({ ...tabProps }) => {
	const { activeTabIndex, setActiveTabIndex, tabs, publicSettings } =
		useAudienceContext();

	// Convert registered tabs to Ant Design tab items
	const tabItems = tabs.map((tab, index) => ({
		key: index.toString(),
		label: (
			<div
				className="px-4 py-2 font-medium"
				style={{
					color:
						activeTabIndex === index
							? publicSettings?.PRIMARY_COLOR?.valueString
							: undefined,
				}}
			>
				{tab.label}
			</div>
		),
		// No content here - content is rendered by AudienceMain
		children: null,
	}));

	// Don't render tabs if no tabs are registered
	if (tabs.length === 0) {
		return null;
	}

	return (
		<Tabs
			// Defaults first
			size="large"
			type="line"
			tabPosition="top"
			tabBarGutter={24}
			// Then spread props (allows overriding)
			{...tabProps}
			// Then required props that should never be overridden
			activeKey={activeTabIndex.toString()}
			onChange={(key) => setActiveTabIndex(parseInt(key, 10))}
			items={tabItems}
			className={`audience-tabs ${tabProps.className || ""}`}
			tabBarStyle={{
				borderBottom: `2px solid ${publicSettings?.PRIMARY_LIGHT_COLOR?.valueString || "#f0f0f0"}`,
				...tabProps.tabBarStyle,
			}}
		/>
	);
};

export default AudienceTabs;
